import { render } from "./eb-header.vue?vue&type=template&id=254081c1"
import script from "./eb-header.vue?vue&type=script&lang=ts"
export * from "./eb-header.vue?vue&type=script&lang=ts"
script.render = render

export default script